import { render, staticRenderFns } from "./categoryListDialog.vue?vue&type=template&id=39c57f8a&scoped=true"
import script from "./categoryListDialog.vue?vue&type=script&lang=js"
export * from "./categoryListDialog.vue?vue&type=script&lang=js"
import style0 from "./categoryListDialog.vue?vue&type=style&index=0&id=39c57f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c57f8a",
  null
  
)

export default component.exports